import React from 'react';
import './styles.scss';
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';

const defaultProps = {
  body: {}
};

class LinksPanel extends React.Component {

  render() {

    const links = this.props.body.links;
    if (!links || !links.length) {
      return null;
    }

    return (
        <div>
          <Collapsible
            trigger="Helpful Links"
            open={true}
            triggerClassName="Collapsible__trigger container-rounded text-uppercase u-font-foundation-roman u-textSize-20 pY-15"
            triggerOpenedClassName="Collapsible__trigger is-open  container-top-rounded text-uppercase u-font-foundation-roman u-textSize-20 pY-15"
            contentOuterClassName="info-box-content u-font-foundation-roman u-textSize-18"
            contentInnerClassName="p-30"
          >

            {links.map(function(link, index){
              return (
                <a className="link-info-wrap" href={link.anchor_link} target="_blank" key={index}>
                  <button className="link-info-btn video-player-btn text-btn u-font-foundation-roman">
                    <div>{link.anchor_text}</div>
                  </button>
                </a>
              );
            })}

          </Collapsible>
        </div>
    );
  }
}

LinksPanel.defaultProps = defaultProps;

export default LinksPanel;
